import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { TrackingEvent } from 'webapp/enums/tracking';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsCreateNewSlideTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_CREATE_NEW_SLIDE;
	override trackEvent: TrackingEvent | '' = TrackingEvent.BUBBLE_CREATE_A_NEW_SLIDE_REPORT;

	get id(): string {
		return TourId.REPORTS__CREATE_NEW_SLIDE;
	}

	override get keyForPersistantDone(): string {
		return ReportsCreateNewSlideTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.RIGHT,
				allowStacked: false,
				attachTo: () => {
					return $('.report_nav .add .type--selector').eq(0);
				},
			},
		];
	}

	override start(): void {
		super.start();
		this.markDone(); // just one step, once seen, it's done
	}

	override onExplicitClose(): void {
		this.flowTourReportsSlidesService.endAllTours();
		super.onExplicitClose();
	}
}
